import { Component, OnInit } from '@angular/core';
import {ActivatedRoute } from '@angular/router';
import { ExternalApisService } from 'src/app/services/external-apis.service';
import { GlobalConstants } from '../global-constants';
// import { SplashScreenStateService } from '../services/splash-screen-state-service';


@Component({
  selector: 'app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.css']
})
export class PhotoComponent implements OnInit {
  public currentCount = 0;
  public item1 = '';
  public item2 = '';
  public theHtmlString ="";
  public photosPath = GlobalConstants.photosServerPath; 
  retItem: any;
  album: any;
  image: any;

  constructor(private route: ActivatedRoute, private externalApis: ExternalApisService ) //,private splashScreenStateService: SplashScreenStateService)
   { 


  }

  ngOnInit() {

  //   setTimeout(() => {
  //     this.splashScreenStateService.stop();
      
  //  }, 500);

    this.route.params.subscribe( params => {console.log(params);
      this.album = params.album;
      this.image = params.id;
      this.retItem = "ready";
      // this.LoadData(this.image);


    });



  }

  LoadData(id:any ) {
    
    this.externalApis.getPhotosByGallery(id).subscribe((data) => {
      this.retItem = data;
      console.log(this.retItem);
        this.theHtmlString = this.retItem.html_content;
       // this.splashScreenStateService.stop();
    }), 
    err => {
         console.log(err);
      }
  }

}
